module.exports = __webpack_public_path__ + "static/media/bgShare3.0a5317a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/wechatShare/components/images/bgShare3.png
// module id = 357
// module chunks = 0